module.exports = __webpack_public_path__ + "img/heat.7549a770.svg";